var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2276 18.0974C18.5131 18.2473 18.5131 18.656 18.2276 18.8058L10.7342 22.7388C10.4679 22.8786 10.1483 22.6854 10.1483 22.3846L10.1483 14.5186C10.1483 14.2178 10.4679 14.0246 10.7342 14.1644L18.2276 18.0974Z",
    stroke: "#979794",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2276 18.0974C28.5131 18.2473 28.5131 18.656 28.2276 18.8058L20.7342 22.7388C20.4679 22.8786 20.1483 22.6854 20.1483 22.3846L20.1483 14.5186C20.1483 14.2178 20.4679 14.0246 20.7342 14.1644L28.2276 18.0974Z",
    stroke: "#979794",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599939,
    y: 0.6,
    width: 36.2194,
    height: 36.2194,
    rx: 18.1097,
    stroke: "#979794",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.0bf7497b1c220455a4f992fb682221d0.svg";
export { ForwardRef as ReactComponent };